'use client';

import Image, { ImageProps } from 'next/image';
import { ComponentProps, useContext } from 'react';
import { AppConfigContext } from '@/features/app-providers/app-config-provider';
import { Optional } from '@/shared/model/Optional';
import { Layout } from '@/shared/ui/layout';

type Props = Optional<ImageProps, 'src' | 'alt'> & {
    variant?: 'top' | 'footer';
    placement?: 'top' | 'footer';
    media?: ComponentProps<typeof Layout>['media'];
};

export const Logo = ({ media, variant, placement, ...props }: Props) => {
    const ctx = useContext(AppConfigContext);
    const isFooter = (placement ?? variant) === 'footer';
    const logo = isFooter ? ctx.footerLogo : ctx.logo;

    if (!logo.src) {
        return null;
    }

    return (
        <Layout
            element={Image}
            media={{ ...media, initial: { objectFit: 'contain', width: 'auto', ...media?.initial } }}
            src={logo.src}
            alt="Logo"
            width={82}
            height={82}
            unoptimized
            {...props}
        />
    );
};
